export enum EmailTemplatePurpose {
    /// <summary>
    /// 
    /// </summary>
    Unspecified = 0,
    MemberGetsActivated = 1,
    MemberGetsActivatedNotification = 2,
}